import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { Link, useStaticQuery, graphql } from "gatsby"

import { css } from "@emotion/react"
import { rgba } from "polished"

import useMixins, { fontSize, globalColors, cmsStyle } from "../css-functions"

const NewsEvents = ({
  pcTitle,
}) => {
  const NUMBER_OF_POSTS = 5

  const [ postsToShow, setPostsToShow ] = useState(NUMBER_OF_POSTS)
  const [ scrollPos, setScrollPos ] = useState(0)

  const mixins = useMixins()

  const target = useRef(null)

  const { allMarkdownRemark } = useStaticQuery(graphql`
    query Events {
      allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "events-page"}}}, sort: {order: DESC, fields: frontmatter___date}) {
        edges {
          node {
            html
            frontmatter {
              title
              date(formatString: "YYYY.MM.DD")
              tags
            }
            fields {
              slug
            }
            id
          }
        }
      }
    }
  `)

  useEffect(() => {
    const moreButton = target.current

    const handlePos = () => {
      setScrollPos(window.scrollY)
    }

    const handleLoadMore = () => {
      setPostsToShow(postsToShow + NUMBER_OF_POSTS)
      window.scrollTo(0, scrollPos)
    }

    handlePos()

    window.addEventListener(`scroll`, handlePos)

    if ( postsToShow < allMarkdownRemark.edges.length ) {
      moreButton.addEventListener(`click`, handleLoadMore)
    }

    return () => {
      window.removeEventListener(`scroll`, handlePos)
      if ( postsToShow < allMarkdownRemark.edges.length ) {
        moreButton.removeEventListener(`click`, handleLoadMore)
      }
    }
  }, [ postsToShow, scrollPos, allMarkdownRemark.edges.length ])

  const style = {
    section: css`
      ${ mixins.default.sectionStyle }
    `,
    listItem: css`
      ${cmsStyle.news.listItem}
    `,
    content: css`
      ${cmsStyle.news.content}
    `,
    subHeader: css`
      ${cmsStyle.news.subHeader}
    `,
    label: css`
      ${cmsStyle.news.label}
    `,
    publishedAt: css`
      ${cmsStyle.news.publishedAt}
    `,
    title: css`
      ${cmsStyle.news.title}
    `,
    markdown: css`
      ${cmsStyle.news.markdown}
    `,
    button: css`
      padding: 32px 0;
      width: 100%;
      cursor: pointer;
      transition: 0.4s ease;
      position: relative;
      ${fontSize(11)}
      font-family: "Noto Serif JP";
      &::after {
        content: "";
        display: block;
        width: 16px;
        height: 16px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%) rotate(45deg);
        border-right: 1px solid ${rgba(globalColors.black, 0.6)};
        border-bottom: 1px solid ${rgba(globalColors.black, 0.6)};
      }
      &:hover {
        opacity: 0.8;
        transition: 0.2s ease;
      }
    `,
    navigateButton: css`
      ${ mixins.default.goDetailButtonStyle }
    `,
  }

  return (
    <>
      { pcTitle }
      <section css={ style.section }>
        <ul>
          { allMarkdownRemark.edges.slice(0, postsToShow).map(({ node }) => (
            <li
              key={ node.id }
              css={style.listItem}
            >
              <div css={style.content}>
                <p css={style.subHeader}>
                  <span
                    css={style.label}
                    className="label--events"
                  >
                    { node.frontmatter.tags[0] }
                  </span>
                  <span css={style.publishedAt}>
                    { node.frontmatter.date }
                  </span>
                </p>
                <h2 css={style.title}>{ node.frontmatter.title }</h2>
                <div
                  dangerouslySetInnerHTML={{ __html: node.html }}
                  css={style.markdown}
                />
              </div>
            </li>
          )) }
          { postsToShow < allMarkdownRemark.edges.length &&
            <li>
              <button
                ref={ target }
                css={style.button}
              >
                もっと見る
              </button>
            </li>
          }
        </ul>
      </section>
      <section css={ style.section }>
        <Link
          to="/works/?t=exhibitions"
          css={ style.navigateButton }
        >
          過去の活動はこちら
        </Link>
      </section>
    </>
  )
}

NewsEvents.propTypes = {
  pcTitle: PropTypes.object,
}

export default NewsEvents
